<div *ngIf="authReady; else waitingAuth" class="wrapper" [class.hidden]="!isMenuLoaded">
    <!-- Header -->
    <!-- Header -->
    <header>
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-xs-12">
                            <span class="g_time">
                                Серверное время: <span class="dateTime-container">{{dateTime}} {{timeZone}}</span>
                            </span>
              </div>
              <div class="col-xs-12">
                <a href="/etp_front/support-request/add" class="g__support__link g__support__link--green">
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                  <span>Поддержка</span>
                </a>
                <a href="tel:88007775757" class="g_tel">8 800 777-57-57</a>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right gov-link">
          </div>
          <div class="col-sm-4">
            <div class="g_time g__enter profile" *ngIf="isLoging()">
              <span class="username">{{username}}</span>
              <br>
              <span>{{organization}}</span>
              <br>
              <span class="dateTime-container">{{dateTimeUser}}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="navbar navbar-expand-lg navbar-dark">
      <div class="container">
        <a class="navbar-brand" href="{{home_url}}" *ngIf="is_home_url_absolute();else relative">
          <img src="assets/img/logo.png" title="Российский аукционный дом" />
        </a>
        <ng-template #relative>
          <a class="navbar-brand" routerLink="{{home_url}}">
            <img src="assets/img/logo.png" title="Российский аукционный дом" />
          </a>
        </ng-template>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <app-menu (menuLoaded)="afterLoadedMenu($event)" [isLogging]="isLoging()"></app-menu>
          <div class="form-inline my-2 my-lg-0 nav-right">
            <img src="assets/img/icon-people.png" title="Российский аукционный дом" class="rounded-circle" />
            <!--<a class="btn btn-link text-white" (click)="testa()">Тест...</a>-->
            <ng-container *ngIf="!isLoging()">
              <a class="btn btn-link text-white" *ngIf="regExternalLink.test(auth_url); else loggin" href="{{ auth_url }}">Войти</a>
              <ng-template #loggin>
                <a class="btn btn-link text-white" routerLink="{{ auth_url }}">Войти</a>
              </ng-template>
            </ng-container>
            <a class="btn btn-link text-white" *ngIf="isLoging()" (click)="logout()">Выйти</a>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <!-- Main content -->
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-1"></div>
        <div class="col-md-10" *ngIf="isMenuLoaded">
          <!-- Breadcrumb TODO -->
          <router-outlet></router-outlet>
        </div>
        <div class="col-md-1"></div>
      </div>
      <br/>
      <br/>
      <br/>
    </div>

    <!-- Footer -->
    <footer class="footer" style="position:fixed;">
      <div class="container">
        <div class="row">
          <div class="col-md-4 logos">
            <img src="/assets/img/Sberbank.svg" alt=""><span>партнер</span><img src="/assets/img/logo2.svg" alt="">
          </div>
          <div class="col-md-8 copy">
            © 2010-{{currentYear}} Российский аукционный дом – всероссийская универсальная электронная площадка<br>
            8 800 777-57-57 (звонок по России бесплатный)<br>
            <a href="/etp_front/support-request/add">Обращение в техподдержку</a>
          </div>
        </div>
      </div>
    </footer>
  </div>

<ng-template #waitingAuth>
  <div id="cube-loader">
    <div class="caption">
      <div class="cube-loader">
        <div class="cube loader-1"></div>
        <div class="cube loader-2"></div>
        <div class="cube loader-4"></div>
        <div class="cube loader-3"></div>
      </div>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/app.component.html